import { useEffect } from 'react';

import { util } from '@core/constant';

const events = ['mousemove', 'mousedown', 'click', 'scroll', 'keypress'];

export function useIdleTimer(minutes: number, callback: () => void) {
  let timeout: NodeJS.Timeout | null = null;

  const restartAutoReset = () => {
    if (timeout) {
      clearTimeout(timeout);
    }

    timeout = setTimeout(() => {
      callback();
    }, minutes * util.TIMEOUT_TIMER_COEF);
  };

  useEffect(() => {
    // initiate timeout
    restartAutoReset();

    // listen for mouse events
    events.forEach((event) => window.addEventListener(event, restartAutoReset));

    // cleanup
    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
      events.forEach((event) => window.removeEventListener(event, restartAutoReset));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
